import { useTranslate } from "@similarweb/i18n-provider";
import { Flex } from "@similarweb/ui-components/foundations";

import CardsWrapper from "app/pages/sales-intelligence/modules/manage-integrations/components/CardsWrapper/CardsWrapper";
import ConnectorCard from "app/pages/sales-intelligence/modules/manage-integrations/components/integration-cards/ConnectorCard/ConnectorCard";
import { CRMIntegrationCard } from "app/pages/sales-intelligence/modules/manage-integrations/components/integration-cards/CRMIntegrationCard/CRMIntegrationCard";
import { CONNECTORS } from "app/pages/sales-intelligence/modules/manage-integrations/constants/connectors";
import { useCRMIntegrationStatusQuery } from "app/pages/sales-intelligence/modules/manage-integrations/query/queries/useCRMIntegrationStatusQuery";
import {
    MANAGEMENT_CONNECTORS_LABEL,
    MANAGEMENT_CRMS_LABEL,
} from "app/pages/sales-intelligence/pages/management/translations/managementKeys";
import { ExportIntegrations } from "app/pages/sales-intelligence/pages/management/types/types";

const CRMIntegrationsContainer = () => {
    const { translate } = useTranslate();

    const salesforceStatusQuery = useCRMIntegrationStatusQuery(ExportIntegrations.salesforce);
    const hubspotStatusQuery = useCRMIntegrationStatusQuery(ExportIntegrations.hubspot);
    const dynamicsStatusQuery = useCRMIntegrationStatusQuery(ExportIntegrations.dynamics);

    const isCrmLoading =
        salesforceStatusQuery.isLoading || hubspotStatusQuery.isLoading || dynamicsStatusQuery.isLoading;

    return (
        <Flex
            flexDirection="column"
            gap="24px"
        >
            <CardsWrapper title={translate(MANAGEMENT_CRMS_LABEL)}>
                <CRMIntegrationCard
                    integrationName={ExportIntegrations.salesforce}
                    isLoading={isCrmLoading}
                    crmData={salesforceStatusQuery.data}
                    onRefetch={salesforceStatusQuery.silentRefetch}
                />
                <CRMIntegrationCard
                    integrationName={ExportIntegrations.hubspot}
                    isLoading={isCrmLoading}
                    crmData={hubspotStatusQuery.data}
                    onRefetch={hubspotStatusQuery.silentRefetch}
                />
                <CRMIntegrationCard
                    integrationName={ExportIntegrations.dynamics}
                    isLoading={isCrmLoading}
                    crmData={dynamicsStatusQuery.data}
                    onRefetch={dynamicsStatusQuery.silentRefetch}
                />
            </CardsWrapper>

            <CardsWrapper title={translate(MANAGEMENT_CONNECTORS_LABEL)}>
                {CONNECTORS.map((connector) => (
                    <ConnectorCard
                        key={connector.id}
                        titleKey={connector.titleKey}
                        iconName={connector.iconName}
                        descriptionKey={connector.descriptionKey}
                        connectLink={connector.connectLink}
                        guideLink={connector.guideLink}
                        trackingName={connector.trackingName}
                        dataAutomation={`connector-${connector.id}`}
                    />
                ))}
            </CardsWrapper>
        </Flex>
    );
};

export default CRMIntegrationsContainer;
